import React, { useCallback } from 'react';
import NotificationBanner from 'design-system/NotificationBanner';
import { selectIsFitForDebtConsolidation, selectIsGBUser, } from 'reducers/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import useMonevoEntry from 'features/borrow/monevo/hooks/useMonevoEntry';
const ConsolidateDebt = () => {
    const dispatch = useAppDispatch();
    const openMonevo = useMonevoEntry();
    const onCancel = useCallback(() => {
        dispatch(setDeviceSettingsKey('didCloseConsolidateDebtBanner', true));
    }, []);
    const handleContinue = useCallback(() => {
        openMonevo('DEBT');
    }, [openMonevo]);
    return (<NotificationBanner noMarginBottom noMarginTop onCancel={onCancel} title="Consolidate debt" cancelButtonTitle="Dismiss" positiveButtonTitle="Continue" onPositiveBtnPress={handleContinue} description="See if you can consolidate your credit card debt with a loan"/>);
};
const ConsolidateDebtWrapper = () => {
    const didOpen = useAppSelector((state) => state.deviceSettings.didCloseConsolidateDebtBanner);
    const isFitForDebtConsolidation = useAppSelector(selectIsFitForDebtConsolidation);
    const isGBUser = useAppSelector(selectIsGBUser);
    if (!isGBUser || !isFitForDebtConsolidation || didOpen) {
        return null;
    }
    return <ConsolidateDebt />;
};
export default ConsolidateDebtWrapper;
